import React from 'react'
require('ta-semantic-ui/semantic/dist/components/item.css')
require('ta-semantic-ui/semantic/dist/components/image.css')
require('ta-semantic-ui/semantic/dist/components/grid.css')
require('ta-semantic-ui/semantic/dist/components/header.css')

/**
 * Render a profile block.
 * @param {string} props.name Name of the person.
 * @param {string} props.avatarSrc Source URL of the avatar image.
 * @param {string} props.children The description of the person. Placed
 * between the <Profile> tages.
 * @returns {XML}
 */
export default function profile (props) {
  return (
    <section className='ui grid profile' >
      <div className='five wide column'>
        <img src={props.avatarSrc} alt={`Bild von ${props.name}`}
          className='ui circular fluid image' />
      </div>
      <div className='eleven wide column'>
        <h3 className='ui small infographic header'>{props.name}</h3>
        <div className='description'>
          {props.children}
        </div>
      </div>
    </section>

  )
}

profile.propTypes = {
  children: React.PropTypes.any,
  name: React.PropTypes.string.isRequired,
  avatarSrc: React.PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/profile/index.js